import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35af560f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "user",
  class: "form-view"
}

import { computed, defineAsyncComponent, ref } from "vue";
import { useUserStoreHook } from "@/store/modules/user";
import { storeToRefs } from "pinia";
import { editUserInfoApi } from "@/api/login";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const userStore = useUserStoreHook();
const storeData = storeToRefs(userStore);
const formData = storeData.userInfo;

// 定义组件
const UserInfo = defineAsyncComponent(() => import('./components/UserInfo.vue'));
const SafeInfo = defineAsyncComponent(() => import('./components/SafeInfo.vue'));
const AuthInfo = defineAsyncComponent(() => import('./components/AuthInfo.vue'));

/**
 * 加载动画显示状态
 */
const loading = ref(false);

/**
 * 保存信息
 */
const saveData = (field: string, value: string, data: any = null, showMsg: boolean = true) => {
  if (!data) {
    if (formData.value[field] === value) return ElMessage.info('请修改后再保存');
    formData.value[field] = value;
  } else {
    formData.value = Object.assign({}, formData.value, data);
  }
  editUserInfoApi(formData.value).then(() => {
    if (showMsg) ElMessage.success('保存成功');
    refresh();
  }).finally(() => {
    loading.value = false;
  })
};

/**
 * 刷新页面
 */
const refresh = async () => {
  await userStore.getUserInfo();
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UserInfo), {
      "form-data": _unref(formData),
      onSaveData: saveData
    }, null, 8, ["form-data"]),
    _createVNode(_unref(SafeInfo), {
      "form-data": _unref(formData),
      onSaveData: saveData,
      onRefreshData: refresh
    }, null, 8, ["form-data"]),
    _createVNode(_unref(AuthInfo), {
      "form-data": _unref(formData),
      onSaveData: saveData
    }, null, 8, ["form-data"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})